export const MOBILE_WEBVIEW_WARNING_TEXT = 'To log in using Google or Facebook, open waves.com in Safari or Chrome.';

export enum InAppBrowserType {
    UnknownWebview = 0,
    Facebook = 1,
    Instagram = 2,
    Twitter = 3,
    Snapchat = 4,
    LinkedIn = 5,
    Pinterest = 6,
    Google = 7,
}

export interface IInAppBrowserResult {
    isInAppBrowser: boolean;
    type?: InAppBrowserType;
    description?: string;
}

interface IInAppBrowserItem {
    pattern: RegExp;
    type: InAppBrowserType;
    description: string;
}

// https://www.whatismybrowser.com/
// https://deviceatlas.com/
const inAppBrowserPatterns: IInAppBrowserItem[] = [
    { pattern: /FB_IAB|FBAN|FBAV/, type: InAppBrowserType.Facebook, description: 'Facebook' },
    { pattern: /Instagram/, type: InAppBrowserType.Instagram, description: 'Instagram' },
    { pattern: /Twitter/, type: InAppBrowserType.Twitter, description: 'Twitter' },
    { pattern: /Snapchat/, type: InAppBrowserType.Snapchat, description: 'Snapchat' },
    { pattern: /LinkedIn/, type: InAppBrowserType.LinkedIn, description: 'LinkedIn' },
    { pattern: /Pinterest/, type: InAppBrowserType.Pinterest, description: 'Pinterest' },
    // { pattern: /GSA|wv.*Chrome\/\d+/, type: InAppBrowserType.Google, description: 'Google' },
];

export const isInAppBrowser = () : IInAppBrowserResult => {
    const userAgent = navigator.userAgent;

    for (const { pattern, type, description } of inAppBrowserPatterns) {
        if (pattern.test(userAgent)) {
            return {
                isInAppBrowser: true,
                type,
                description
            };
        }
    }

    if (userAgent.includes('Android') &&
        (userAgent.includes('wv') || userAgent.includes('WebView'))) {
        return {
            isInAppBrowser: true,
            type: InAppBrowserType.UnknownWebview,
            description: 'Unknown Webview'
        };
    }

    return {
        isInAppBrowser: false
    };
};